import { applySpec, pipe, path, ifElse, prop, propOr, isEmpty, join, either, filter } from 'ramda';

import { ID, PRESSURE, DATE } from 'store/examinations';
import { parseDate } from 'utils';

const getPressure = pipe(
  propOr([], PRESSURE),
  filter((val) => val !== null),
  ifElse(isEmpty, () => '–', join(', '))
);
const getDate = either(prop(DATE), path(['meta', 'modified']));

export const handleItems = (list, current, side) =>
  (list || []).reduce(
    (acc, item) =>
      item[ID] === current
        ? acc
        : [...acc, applySpec({ id: prop(ID), value: pipe(propOr({}, side), getPressure), date: pipe(getDate, parseDate) })(item)],
    []
  );
